export default {
  name: "Minimum Job Requirements",
  prefix: "E.b",
  sections: [
    {
      fields: [
        {
          isGroup: {
            code: "E.b.1",
            machine_name: "primaryEducationLevel",
            label: "Minimum U.S. diploma/degree required?",
            required: true,
            tooltip:
              "Identify whether the minimum U.S. diploma or degree required by the employer for the job opportunity is none, high school/GED, Associates, Bachelor’s, Master’s, Doctorate, or Other.",
            fields: [
              {
                widget: "radio",
                choice: "None",
                value: "NONE",
                validate: ["required"],
                clearSchema: ["otherEducation"],
              },
              {
                widget: "radio",
                choice: "High School/GED",
                value: "HIGH SCHOOL/GED",
                validate: ["required"],
                clearSchema: ["otherEducation"],
              },
              {
                widget: "radio",
                choice: "Associate's",
                value: "ASSOCIATE'S",
                validate: ["required"],
                clearSchema: ["otherEducation"],
              },
              {
                widget: "radio",
                choice: "Bachelor's",
                value: "BACHELOR'S",
                validate: ["required"],
                clearSchema: ["otherEducation"],
              },
              {
                widget: "radio",
                choice: "Master's",
                value: "MASTER'S",
                validate: ["required"],
                clearSchema: ["otherEducation"],
              },
              {
                widget: "radio",
                choice: "Doctorate (PhD)",
                value: "DOCTORATE (PHD)",
                validate: ["required"],
                clearSchema: ["otherEducation"],
              },
              {
                widget: "radio",
                choice: "Other Degree (JD, MD, etc.)",
                value: "OTHER DEGREE (JD, MD, ETC.)",
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "E.b.1a",
          machine_name: "otherEducation",
          widget: "text",
          label:
            'If "Other degree" in question E.b.1, specify the U.S. diploma/degree required.',
          validate: ["required", "noNAs"],
          maxLength: 36,
          isVisible: {
            when: "primaryEducationLevel",
            is: "OTHER DEGREE (JD, MD, ETC.)",
          },
          tooltip: `If “Other” in question 1, enter the specific U.S. diploma or degree required. (Example: JD, MD, DDS, etc.).  If the answer to question 1 is <u>not</u> “Other,” enter “N/A.”`,
        },
        {
          code: "E.b.1b",
          machine_name: "major",
          widget: "text",
          label: `Enter the major(s) and/or field(s) of study required by the employer for the job opportunity. You may list more than one field and/or more than one related major.  If the answer to question 1 is “None” or “High School”, enter “N/A.”`,
          maxLength: 38,
          validate: ["required"],
          tooltip:
            "Enter the major(s) and/or field(s) of study required by the employer for the job opportunity. You may list more than one field and/or more than one related major. If the answer to question 1 is “None” or “High School/GED”, enter “N/A.”",
        },
        {
          isGroup: {
            code: "E.b.2",
            machine_name: "secondDiploma",
            label: "Does the employer require a second U.S. diploma/degree?",
            required: true,
            tooltip: `If the employer requires a second U.S. diploma or degree for the job opportunity, mark “Yes.”  Otherwise, mark “No.”`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["secondDiplomaMajor"],
              },
            ],
          },
        },
        {
          code: "E.b.2a",
          machine_name: "secondDiplomaMajor",
          widget: "text",
          label:
            'If "Yes" in question E.b.2, indicate the second U.S. diploma/degree and the major(s) and/or field(s) of study required.',
          validate: ["required", "noNAs"],
          maxLength: 192,
          isVisible: {
            when: "secondDiploma",
            is: "YES",
          },
          tooltip: `If “Yes” in question 2, enter the specific second U.S. diploma or degree required.  If the answer to question 2 is “No”, enter “N/A.”`,
        },
        {
          isGroup: {
            code: "E.b.3",
            machine_name: "trainingRequired",
            // widget: "radio",
            label: "Is training for the job opportunity required?",
            required: true,
            tooltip: `If the employer requires training for the job opportunity, mark “Yes.” Otherwise, mark “No.”  Training may include, but is not limited to: programs, coursework, or training experience (other than employment).  When answering this question, do not duplicate requirements – the training required should not be counted as education or experience required.`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["numberOfMonthsTraining", "nameRequiredTraining"],
              },
            ],
          },
        },
        {
          code: "E.b.3a",
          machine_name: "numberOfMonthsTraining",
          widget: "text",
          label: "Number of months of training",
          validate: ["required", "number"],
          width: 2,
          maxLength: 4,
          isVisible: {
            when: "trainingRequired",
            is: "YES",
          },
          tooltip: `If “Yes” in question 3, enter the number of months of training required by the employer for the job opportunity. If the answer to question 3 is “No”, enter “0” (zero).  When answering this question, do not duplicate time requirements – the training time required should not be counted as (added to) education or experience time required.`,
        },
        {
          code: "E.b.3b",
          machine_name: "nameRequiredTraining",
          widget: "text",
          label: "Field/Names of training",
          validate: ["required", "noNAs"],
          maxLength: 60,
          isVisible: {
            when: "trainingRequired",
            is: "YES",
          },
          tooltip: `If “Yes” in question 3, enter the field(s) and/or name(s) of the training required by the employer for the job opportunity.  You may list more than one field and/or more than one name. If the answer to question 3 is “No”, enter “N/A.”`,
        },
        {
          isGroup: {
            code: "E.b.4",
            machine_name: "empExperienceRequired",
            label: "Is employment experience required?",
            required: true,
            tooltip: `If the employer requires employment experience, mark “Yes.”  Otherwise, mark “No.”`,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["empExperienceMonths", "occupationRequired"],
              },
            ],
          },
        },
        {
          code: "E.b.4a",
          machine_name: "empExperienceMonths",
          widget: "text",
          label:
            'If "Yes" in question E.b.4, specify the number of months of experience required.',
          validate: ["required", "number"],
          width: 2,
          maxLength: 4,
          isVisible: {
            when: "empExperienceRequired",
            is: "YES",
          },
          tooltip: `If “Yes” in question 4, enter the number of months of experience required by the employer.  If the answer to question 4 is “No”, enter “0” (zero).`,
        },
        {
          code: "E.b.4b",
          machine_name: "occupationRequired",
          widget: "text",
          label: "Indicate the occupation(s) required.",
          validate: ["required", "noNAs"],
          maxLength: 200,
          isVisible: {
            when: "empExperienceRequired",
            is: "YES",
          },
          tooltip: `If “Yes” in question 4, enter the occupation in which experience is required by the employer for the job opportunity.  If the answer to question 4 is “No”, enter “N/A.”`,
        },
        {
          code: "E.b.5",
          machine_name: "specialRequirements",
          widget: "text_area",
          label:
            "Special Requirements - List specific skills, licenses/certificates/certifications and requirements of the job opportunity.",
          validate: ["required", "noNAs"],
          rows: 5,
          inputLimit: 4000,
          tooltip: `Enter the job related special requirements.  Examples are shorthand and typing speeds, specific foreign language proficiency, and test results.`,
        },
      ],
    },
  ],
};
